const CMD_PERSONS_PATH = '/delegate/customer-master-data/v3/persons?owner-only=true';

export const loadSalutation = (): void => {
  const CMD_SALUTATION = $('.cmd-salutation');

  if (CMD_SALUTATION.length === 0) {
    return;
  }

  $.get(CMD_PERSONS_PATH, response => {
    if (response.length > 0) {
      const { firstName, lastName, genderCode } = response[0];

      let genderSalutation = '';
      let salutationText = '';

      if (genderCode && genderCode.alias === 'male gender') {
        genderSalutation = CMD_SALUTATION.data('male');
      } else if (genderCode && genderCode.alias === 'female gender') {
        genderSalutation = CMD_SALUTATION.data('female');
      }

      if (firstName !== undefined && firstName !== '' && lastName !== undefined && lastName !== '') {
        if (genderSalutation.length > 0) {
          salutationText += `${genderSalutation} ${lastName}`;
        } else {
          salutationText += `${firstName} ${lastName}`;
        }
      }

      CMD_SALUTATION.text(salutationText);
    }
  });
};
